import { ConsumerPaymentMethods } from "../../../Pages/Payment Methods";

import { modalVariants } from "../../../Utils/constants";

export default function renderManagePaymentMethods(modalContext, props) {
  const { updateModalComponent, setModalTitle, setModalClassName, setModalVariant, pushModalStack } = modalContext;
  const { isBackupPayment } = props;

  pushModalStack(() => renderManagePaymentMethods(modalContext, props));
  updateModalComponent(() => <ConsumerPaymentMethods presentedForSelection {...props} />);
  setModalTitle(`Select ${isBackupPayment ? "Backup Card" : "Payment Methods"}`);
  setModalClassName("rendering-page-content");
  setModalVariant(modalVariants.formDialog);
}
